module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-container collecte-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h1', [_vm._v("Importer des Rondes en masse")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b7bca4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/rondes/RondesImportModal.vue
// module id = 1862
// module chunks = 2